export default {
  bannerList: [],
};
